'use client';
import { useQueries } from '@tanstack/react-query';
import { useTrackedOrders } from '@/entities/order/lib/useTrackedOrders';
import { OrderProgress, orderStateMap } from '@/entities/order/ui/order-progress';
import { QueryApi } from '@/features/query/api';
import './order-progress-list.scss';

type Props = {
    onOrderClick(orderId: string): void;
};

export const OrderProgressList = ({ onOrderClick }: Props) => {
    const [trackedOrders] = useTrackedOrders();
    const ordersQueries = useQueries({
        queries: trackedOrders.map(({ id }) => ({
            ...QueryApi.Order.queries.Order(id),
        })),
    });

    const orders = ordersQueries.filter((query) => query.data).map((query) => query.data!);

    return (
        <div className="order-progress-list" data-testid="order-progress-list">
            {orders.map((order) => (
                <button
                    key={order.id}
                    className="order-progress-list__item"
                    onClick={() => onOrderClick(order.id)}
                    data-testid="order-progress-list-item"
                    data-number={order.number}
                    data-order-id={order.id}
                    data-order-status={order.status.definition.identifier}
                >
                    <OrderProgress
                        as="div"
                        state={orderStateMap[order.status.definition.identifier!]}
                        data-testid="order-progress-list-progress"
                    />
                    <span data-testid="order-progress-list-order-number" data-value={order.number}>
                        {order.scopedNumber}.
                    </span>
                </button>
            ))}
        </div>
    );
};
